/** @format */

import { EmployeeBusinessState } from './type';

const InitialEmployeeBusinessState: EmployeeBusinessState = {
    employee: {},
};

export default InitialEmployeeBusinessState;